import { GetPermissionsDrive } from '@/modules/drive/domain/models/GetPermissionsDrive'

import { axios, Response } from '../index'

const getPermissionsDrive = (
  personaId: string
): Response<GetPermissionsDrive> => {
  return axios.get(`/v1/profiles/permissions/${personaId}`)
}

export default getPermissionsDrive
